import { Component, OnInit, Input, Output,
         EventEmitter, ViewChild } from '@angular/core';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'newsletter-form-modal',
  templateUrl: './newsletter-form-modal.component.html',
  styleUrls: ['./newsletter-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class NewsletterFormModalComponent implements OnInit {
  @ViewChild('previewImg') previewImg;

  @Input()  selectedNewsletter: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  newsletter = {
    title: "",
    fileName: "",
    fileSize: 0,
    creatorName: ""
  }

  uploadedFile: File;

  constructor(private dbService: DBService) { }

  ngOnInit() {
    if (this.selectedNewsletter) {
      this.newsletter = this.selectedNewsletter;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {

    if (this.uploadedFile) {
      this.newsletter.fileName = this.uploadedFile.name;
      this.newsletter.fileSize = this.uploadedFile.size;
    }

    console.log(this.newsletter)

    if (this.selectedNewsletter) {
      this.dbService.updateNewsletter(this.selectedNewsletter.$key,
                                      this.newsletter,
                                      this.uploadedFile);
    } else {
      this.dbService.addNewsletter(this.newsletter, this.uploadedFile);
    }

    this.onHideModal();
  }

  onFileChange(event) {
    let file = event.target.files[0];
    this.uploadedFile = file;
  }

}



// WEBPACK FOOTER //
// ./src/app/newsletter/newsletter-form-modal/newsletter-form-modal.component.ts